<div class="bary-input-checkbox">
  <mdb-checkbox
    [default]="true"
    #mdbCheckbox
    [inline]="inline"
    [id]="id"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [attr.disabled]="disabled"
    [class.ng-invalid]="control.invalid"
    [formControl]="control"
    (change)="onChangeEvent.emit($event)"
    [name]="id"
    >{{ label }}
    <ng-content></ng-content>
    <span class="asterisk" *ngIf="isRequired"></span>
    <jhi-bary-icon *ngIf="tooltip" icon="question-circle" [faDirective]="FAS" [title]="tooltip" class="ml-1"></jhi-bary-icon>
  </mdb-checkbox>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    <span *ngIf="control.hasError('customMessage')" [jhiTranslate]="control?.errors?.customMessage"></span>
  </mdb-error>
</div>
